// extracted by mini-css-extract-plugin
export default {"list":"element-of-nature_list__J0JiV","text":"element-of-nature_text__PW7PI"};